const getOfferLetterData = state => state?.offerLetterData?.offerList
const getOfferMetric = state => state?.offerLetterData?.offerMetrics

const selector = {
    getOfferLetterData,
    getOfferMetric
}

export default selector